import { type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  label: string;
  value: string | number;
  icon: LucideIcon;
  index: number;
  trend?: "up" | "down" | "neutral";
}

export function AdminMetricCard({ label, value, icon: Icon, index }: Props) {
  return (
    <div
      className={cn(
        "group relative overflow-hidden rounded-xl border border-border/50 bg-card/60 backdrop-blur-xl p-4",
        "transition-all duration-500 hover:border-primary/40 hover:shadow-lg hover:shadow-primary/10",
        "hover:-translate-y-0.5 animate-slide-up"
      )}
      style={{ animationDelay: `${index * 60}ms`, animationFillMode: "both" }}
    >
      {/* Gradient accent top border */}
      <div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-primary/0 via-primary/60 to-accent/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      {/* Ambient glow */}
      <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full bg-primary/5 blur-2xl group-hover:bg-primary/10 transition-all duration-700" />

      <div className="relative flex items-start justify-between gap-2">
        <div className="space-y-1.5 min-w-0">
          <p className="text-[11px] font-medium text-muted-foreground uppercase tracking-wider truncate">
            {label}
          </p>
          <p className="text-2xl font-bold tracking-tight font-display">
            {typeof value === "number" ? value.toLocaleString() : value}
          </p>
        </div>
        <div className="flex-shrink-0 p-2 rounded-lg bg-primary/10 text-primary group-hover:bg-primary/20 transition-colors duration-300">
          <Icon className="w-4 h-4" />
        </div>
      </div>
    </div>
  );
}
